// extracted by extract-css-chunks-webpack-plugin
module.exports = {"breadCrumbs":"SaU3o","breadcrumb-container":"utw8C"};